import { pathOr, path, indexBy, prop } from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { parse } from 'query-string';

import { SET_CATEGORIES } from '../../../constants/categories';
import { appFilterCategorySelector } from '../../app/filter';
import { addDomainEntity, addDomainEntityId } from '../../../helpers';
import { getListWithStatus } from '../../../helpers/selector';
import { isDebugModeSelector } from '../../app/initialization';

const initialByIdState = {};

const byIdReducer = (state = initialByIdState, action) => {
  switch (action.type) {
    case SET_CATEGORIES:
      return action.payload.reduce(addDomainEntity, {});

    default:
      return state;
  }
};

// List of all ids

const initialAllIdsState = [];

const allIdsReducer = (state = initialAllIdsState, action) => {
  switch (action.type) {
    case SET_CATEGORIES:
      return action.payload.reduce(addDomainEntityId, []);

    default:
      return state;
  }
};

export const initialState = {
  byId: initialByIdState,
  allIds: initialAllIdsState,
};

export default combineReducers({ byId: byIdReducer, allIds: allIdsReducer });

/**
 * Create category model to follow UI contact
 */
export const categoryModel = ({
  id,
  translationKey: key,
  status,
  gamesIdList,
}) => ({
  id,
  key,
  status,
  gamesIdList,
});

/**
 * Selectors
 */
const rootSelector = (state) =>
  pathOr(initialState, ['domain', 'categories'], state);
export const categoryListSelector = createSelector(
  rootSelector,
  isDebugModeSelector,
  getListWithStatus(({ byId, allIds }) =>
    allIds.map((id) => categoryModel(byId[id]))
  )
);

export const allCategoryMapSelector = createSelector(
  categoryListSelector,
  (categories) => indexBy(prop('id'), categories)
);

export const getQueryActiveCategory = (state, ownProps) => {
  const search = path(['location', 'search'], ownProps);
  const parsedQuery = parse(search);

  return parsedQuery.category;
};

export const getActiveCategoryName = createSelector(
  appFilterCategorySelector,
  getQueryActiveCategory,

  (activeCategory, queryCategory) => queryCategory || activeCategory
);

export const getLocationFromOwnProps = (_, { location }) => location;
